import React, {Fragment} from 'react';

import cs from 'classnames';

import {useAutoHeightTextarea} from 'app/general/forms/auto-height-textarea-hook';

interface Props {
  id?: string;
  className?: string;
  onBlur: () => void;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  value?: string;
}

export function AutoSizedTextArea({
  id,
  className,
  onBlur,
  onChange,
  disabled,
  value,
  placeholder,
}: Props) {
  const [autoHeightProps, AutoHeightGlobalStyle] = useAutoHeightTextarea({
    onChange,
    stripBreakLines: false,
  });
  return (
    <Fragment>
      <textarea
        {...autoHeightProps}
        style={textareaStyles}
        id={id}
        className={cs(className, autoHeightProps.className)}
        onBlur={onBlur}
        disabled={disabled}
        value={value}
        placeholder={placeholder}
      />
      <AutoHeightGlobalStyle />
    </Fragment>
  );
}
const textareaStyles = {
  maxHeight: 200,
};
